import { render, staticRenderFns } from "./OctMaculaForm.vue?vue&type=template&id=3ff309c6"
import script from "./OctMaculaForm.vue?vue&type=script&lang=js"
export * from "./OctMaculaForm.vue?vue&type=script&lang=js"
import style0 from "./OctMaculaForm.vue?vue&type=style&index=0&id=3ff309c6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports